import Alpine from 'alpinejs';
import InitHero from './initHero';
import InitBadge from './initBadge';
import InitGsap from './initGsap';
import InitSwiper from './initSwiper';
import InitLottie from './initLottie';
import InitPreloader from './initPreloader';
import InitAlpine from './initAlpine';
import InitScrambleText from './initScrambleText';

Alpine.store('ui', {
  modal: {
    open: false,
    title: '',
    content: '',
    size: 'md', // optional: sm, md, lg
  },
  openModal({ title = '', content = '', size = 'md' }) {
    this.modal.title = title;
    this.modal.content = content;
    this.modal.size = size;
    this.modal.open = true;
  },
  closeModal() {
    this.modal.open = false;
  },
});
Alpine.data('makeRequest', InitAlpine.makeRequest);
Alpine.data('globalAlpine', InitAlpine.globalAlpine);

window.Alpine = Alpine;

InitPreloader().then(() => {
  InitHero();
  // window.makeRequest = () => InitAlpine.makeRequest();
  // window.globalAlpine = () => InitAlpine.globalAlpine();
});
InitSwiper();
InitGsap();
InitLottie();
InitScrambleText();

document.addEventListener('DOMContentLoaded', () => {
  Alpine.start();
  const container = document.querySelector('.box--matter');
  if (!container) return;

  const app = InitBadge(
    [
      { id: 'data', label: 'Data' },
      { id: 'Destiny', label: 'Destiny' },
      { id: 'Design', label: 'Design' },
      { id: 'Dynamic', label: 'Dynamic' },
      { id: 'Dimension', label: 'Dimension' },
      { id: 'Dexterity', label: 'Dexterity' },
      { id: 'Define', label: 'Define' },
      { id: 'Domain', label: 'Domain' },
      { id: 'Designate', label: 'Designate' },
      'Drive',
      'Develop',
      'Detail',
      'Dawn',
      'Destiny',
      'Delight',
      'Dare',
      'Discovery',
      'Distinct',
      'Diverse',
      'Direction',
      'Dominate',
    ],

    { debug: false, initialCount: 6, randomInit: true }
  );
  app.add({ id: 'mono', label: '@mono', color: '#dae000' });
  app.add({ id: 'may', label: '@may', color: '#dae000' });
  app.add({ id: 'zero', label: '@zero', color: '#dae000' });
  app.add({ id: 'jja', label: '@ja.jung', color: '#dae000' });
});
